<div *ngIf="priceRows as rows else piloading">

  <p-table id="prodInfoTable" #prodInfoTable
           [value]="rows"
           styleClass="p-datatable-gridlines p-datatable p-datatable-customers p-datatable-sm">

    <ng-template pTemplate="header">
      <tr>
        <th style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: left" width="30%">Currency</th>
        <th style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: center" width="10%">На складе</th>
        <th style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: center" width="10%">Продано</th>
        <th style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: center" width="10%">В резерве</th>
        <th style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: center" width="10%">В пути</th>
        <th style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right" width="10%">Розничная цена</th>
        <th style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right" width="10%">Цена со скидкой ({{basediscount | number:'1.0-1' }}%)</th>
        <th style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right" width="10%">Цена со скидкой ({{qntydiscount | number:'1.0-1' }}%)</th>
        <th style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right" width="10%">Цена со скидкой ({{partnerdiscount | number:'1.0-1' }}%)</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
      <tr>
        <td class="prod-info-currency" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: left">
          <span class="prod-info-currency-code">{{row.code}}</span>
          <span class="prod-info-currency-roles">({{row.roles.join(', ')}})</span>
        </td>
        <!-- stock does not depend on the currency: shown once, on the first row -->
        <ng-container *ngIf="rowIndex === 0 && prodInfo?.[0] as stock; else noStock">
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: center">{{stock.PRODSTOCK | number:'1.0-2' }}</td>
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: center">{{stock.PRODSOLD | number:'1.0-2' }}</td>
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: center">{{stock.PRODRESERVE | number:'1.0-2' }}</td>
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: center">{{stock.PRODONWAY | number:'1.0-2' }}</td>
        </ng-container>
        <ng-template #noStock>
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: center">&nbsp;</td>
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: center">&nbsp;</td>
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: center">&nbsp;</td>
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: center">&nbsp;</td>
        </ng-template>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{row.retail | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{row.base | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{row.qty | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{row.partner | number:'1.2-2' }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #piloading>
  <p>Информация о резервировании загружается...</p>
</ng-template>


